export const handleApiError = (error, rejectWithValue) => {
    if (error.response && error.response.data) {
      return rejectWithValue(error.response.data);
    } else {
      return rejectWithValue(error);
    }
  };
  